
import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { ProfileFormData } from "../../types";

interface BioFieldProps {
  form: UseFormReturn<ProfileFormData>;
}

export const BioField = ({ form }: BioFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="bio"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Bio</FormLabel>
          <FormControl>
            <Textarea
              placeholder="Share something about yourself... What are your travel interests? What experiences are you looking for? What can you offer as a host?"
              className="resize-none min-h-[150px]"
              {...field}
              value={field.value || ""}
            />
          </FormControl>
          <FormDescription>
            A good bio helps hosts and fellow travelers understand your travel style and preferences.
            <span className="block text-xs text-right mt-1">
              {(field.value?.length || 0)}/500 characters
            </span>
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
